import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { FiAlertTriangle, FiSave } from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { editCustomer } from '../layout/store/Thunk';

export const CardDataCustomer = ({ data, variant }) => {

    /**
     * ToDo: Se renderizaran controles de acuerdo a la variante que se indique
     * - Falta enviar mensajes de validacion y validar formulario
     * data: Recibe la informacion del cliente en un objeto
     * variant 1:  Tendra opciones para editar y actualizar informacion del formulario
     * variant 2: Solo mostrara informacion del cliente, Utilizado en Nueva, Seguimiento y Cierre de Orden (create,tracking,close)
     * 
    */

    // console.log(data);


    // Logica para actualizar la data del cliente
    const dispatch = useDispatch();
    const [editMode, setEditMode] = useState(false);
    const { register, handleSubmit, watch, reset, setValue, formState: { errors } } = useForm({});
    const { idCustomer } = useSelector(state => state.customerDetail);
    const { tiposClientes } = useSelector(state => state.catalogos);

    useEffect(() => {
        if (data) {
            setValue("NOMBRE", data?.NOMBRE);
            setValue("TELEFONO", data?.TELEFONO);
            setValue("CELULAR", data?.CELULAR);
            setValue("EMAIL", data?.EMAIL);
            setValue("FECHA_NAC", data?.FECHA_NAC);
            setValue("TIPO_CLIENTE", data?.TIPO_CLIENTE);
        }
    }, [data]);

    const toggleEdit = () => {
        if (editMode) reset(data);
        setEditMode(prev => !prev);
    };

    const saveData = (formData) => {
        setEditMode(false);
        Swal.fire({
            title: 'Atención',
            text: `Está por actualizar la informacion de un cliente:  ¿Desea de continuar con esta acción?`,
            icon: 'question',
            customClass: {
                confirmButton: 'btn btn-primary  me-2',
                cancelButton: 'btn btn-secondary'
            },
            showCancelButton: true,
            confirmButtonText: 'Sí, continuar',
            cancelButtonText: 'No, cancelar',
            buttonsStyling: false
        }).then((result) => {
            if (result.isConfirmed) {
                console.log('Datos actualizados', formData);
                dispatch(editCustomer(formData, idCustomer))
            }
        })
    };

    if (variant == 1) {
        return (
            <div className="card">
                <div className="card-header border-bottom d-flex justify-content-between align-items-center">
                    <h5 className="card-title mb-0 text-black">Datos del Cliente: {data.ID}</h5>
                    <button type="button" className="btn btn-outline-dark" onClick={toggleEdit} > {editMode ? "Cancelar" : " Editar "} </button>
                </div>
                <div className="card-body">
                    <form className='row' onSubmit={handleSubmit(saveData)}>
                        <div className='col-12 mb-2'>
                            <label className="form-label">Nombre:</label>
                            <input {...register('NOMBRE', { required: ' Nombre, requerido' })} className={`form-control ${errors.NOMBRE ? 'is-invalid' : ''}`} placeholder="Nombre cliente" disabled={!editMode} />
                            {
                                errors.NOMBRE &&
                                <div className='text-left-5 mt-2'>
                                    <FiAlertTriangle size="20" color="#dc3545" />
                                    <span className='text-left-10 fw-bold text-danger'><small>{errors.NOMBRE.message}</small></span>
                                </div>
                            }
                        </div>
                        <div className='col-6 mb-2'>
                            <label className="form-label">Telefono:</label>
                            <input {...register('TELEFONO', { required: ' Telefono, requerido' })} className="form-control" placeholder="Teléfono" disabled={!editMode} />
                            {
                                errors.TELEFONO &&
                                <div className='text-left-5 mt-2'>
                                    <FiAlertTriangle size="20" color="#dc3545" />
                                    <span className='text-left-10 fw-bold text-danger'><small>{errors.TELEFONO.message}</small></span>
                                </div>
                            }
                        </div>
                        <div className='col-6 mb-2'>
                            <label className="form-label">Celular:</label>
                            <input {...register('CELULAR', { required: ' Celular, requerido' })} className="form-control" placeholder="Celular" disabled={!editMode} />
                            {
                                errors.CELULAR &&
                                <div className='text-left-5 mt-2'>
                                    <FiAlertTriangle size="20" color="#dc3545" />
                                    <span className='text-left-10 fw-bold text-danger'><small>{errors.CELULAR.message}</small></span>
                                </div>
                            }
                        </div>
                        <div className='col-12 mb-2'>
                            <label className="form-label">Correo:</label>
                            <input {...register('EMAIL', {
                                required: ' Email, requerido',
                                pattern: {
                                    value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                    message: 'Introduce una direccion de correo',
                                },
                            })} className="form-control" placeholder="Correo electrónico" disabled={!editMode} />
                            {
                                errors.EMAIL &&
                                <div className='text-left-5 mt-2'>
                                    <FiAlertTriangle size="20" color="#dc3545" />
                                    <span className='text-left-10 fw-bold text-danger'><small>{errors.EMAIL.message}</small></span>
                                </div>
                            }
                        </div>
                        <div className='col-12 mb-2'>
                            <label className="form-label"> F. Nacimiento: </label>
                            <input type="date" {...register('FECHA_NAC')} className="form-control" disabled={!editMode} defaultValue={Date()} />
                        </div>
                        <div className='col-12 mb-2'>
                            <label className="form-label" > Clasificación: </label>
                            <select className={`form-select ${errors.TIPO_CLIENTE ? 'is-invalid' : ''}`} {...register('TIPO_CLIENTE')} disabled={!editMode}>
                                {
                                    tiposClientes.map((item, index) => (
                                        item.ESTADO == 1 ? <option key={index} value={item.ID} className='text-uppercase' >{item.NOMBRE}</option>
                                            : <option key={index} style={{ display: "none" }} ></option>
                                    ))
                                }
                            </select>
                            {
                                errors.TIPO_CLIENTE &&
                                <div className='text-left-5 mt-2'>
                                    <FiAlertTriangle size="20" color="#dc3545" />
                                    <span className='text-left-10 fw-bold text-danger'><small>{errors.TIPO_CLIENTE.message}</small></span>
                                </div>
                            }
                        </div>
                        <div className='col-12 text-end mt-1'>
                            <button type="submit" className="btn btn-outline-primary " disabled={!editMode} > <FiSave size={22} /> Actualizar</button>
                        </div>
                    </form>
                </div>
            </div>
        )
    }

    if (variant == 2) {
        return (
            <div className="card">
                <div className="card-header border-bottom">
                    <h5 className="card-title mb-0 text-black">Datos del Cliente: {data.id}</h5>
                </div>
                <div className="card-body">
                    <form className='row'>
                        <div className='col-12 mb-2'>
                            <label className="form-label">Nombre:</label>
                            <input type="text" className="form-control" defaultValue={data.name} placeholder="Nombre cliente" disabled />
                        </div>
                        <div className='col-6 mb-2'>
                            <label className="form-label">Telefono:</label>
                            <input type="text" className="form-control" defaultValue={data.phone} placeholder="Telefono" disabled />
                        </div>
                        <div className='col-6 mb-2'>
                            <label className="form-label">Celular:</label>
                            <input type="text" className="form-control" defaultValue={data.cellular} placeholder="Telefono" disabled />
                        </div>
                        <div className='col-12 mb-2'>
                            <label className="form-label">Correo:</label>
                            <input type="text" className="form-control" defaultValue={data.email} placeholder="Correo electronico" disabled />
                        </div>
                        <div className='col-12 mb-2'>
                            <label className="form-label"> Membresía(s): </label><br />
                            <span> {data.membership}</span><br />
                            <span className='text-justify'> {data.membershipDescription}</span><br />
                            <span> Vigencia: {data.validity}</span>
                        </div>
                        <div className='col-12 mb-2 text-center'>
                            <label className="form-label fw-bold">{data.customerID} </label>

                        </div>
                    </form>
                </div>
            </div>
        )
    }
}
